import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("ll_cart")) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("ll_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.id === item.id);
      if (existing) {
        return prev.map((i) => i.id === item.id ? { ...i, qty: i.qty + 1 } : i);
      }
      return [...prev, { ...item, qty: 1 }];
    });
  };

  // Merge a guest cart array into the current cart (used on login)
  const mergeCart = (guestItems) => {
    setItems((prev) => {
      let merged = [...prev];
      guestItems.forEach((gItem) => {
        const existing = merged.find((i) => i.id === gItem.id);
        if (existing) {
          merged = merged.map((i) =>
            i.id === gItem.id ? { ...i, qty: i.qty + gItem.qty } : i
          );
        } else {
          merged = [...merged, gItem];
        }
      });
      return merged;
    });
  };

  const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));

  const updateQty = (id, qty) => {
    if (qty < 1) return removeItem(id);
    setItems((prev) => prev.map((i) => i.id === id ? { ...i, qty } : i));
  };

  const updateNotes = (id, notes) => {
    setItems((prev) => prev.map((i) => i.id === id ? { ...i, notes } : i));
  };

  const clearCart = () => setItems([]);

  const totalItems = items.reduce((sum, i) => sum + i.qty, 0);
  const totalPrice = items.reduce((sum, i) => sum + parseFloat(i.price) * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, mergeCart, removeItem, updateQty, updateNotes, clearCart, totalItems, totalPrice }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
